import {useState} from 'react'
import {Text as RNText, View} from 'react-native'
import {msg, Trans} from '@lingui/macro'
import {useLingui} from '@lingui/react'

import {useKawaiiMode} from '#/state/preferences/kawaii'
import {useSession} from '#/state/session'
import {DesktopFeeds} from '#/view/shell/desktop/Feeds'
import {DesktopSearch} from '#/view/shell/desktop/Search'
import {SidebarTrendingTopics} from '#/view/shell/desktop/SidebarTrendingTopics'
import {
  atoms as a,
  useGutters,
  useLayoutBreakpoints,
  useTheme,
  web,
} from '#/alf'
import {AppLanguageDropdown} from '#/components/AppLanguageDropdown'
import {Divider} from '#/components/Divider'
import {CENTER_COLUMN_OFFSET} from '#/components/Layout'
import {InlineLinkText} from '#/components/Link'
import {ProgressGuideList} from '#/components/ProgressGuide/List'
import {Text} from '#/components/Typography'
import {RoomRulesSection} from './RoomRulesSection'

export function RoomsRightNav() {
  const t = useTheme()
  const {_} = useLingui()
  const {hasSession} = useSession()
  const kawaii = useKawaiiMode()
  const gutters = useGutters(['base', 0, 'base', 'wide'])
  const {rightNavVisible, centerColumnOffset, leftNavMinimal} =
    useLayoutBreakpoints()

  const [legalOpen, setLegalOpen] = useState(false)

  const handleFeedbackClick = () => {
    if (typeof window !== 'undefined' && (window as any).formbricks) {
      ;(window as any).formbricks.track('feedback')
    }
  }

  if (!rightNavVisible) {
    return null
  }

  const width = centerColumnOffset ? 250 : 300

  return (
    <View
      style={[
        gutters,
        a.gap_lg,
        web({
          position: 'fixed',
          left: '50%',
          transform: [
            {
              translateX: 300 + (centerColumnOffset ? CENTER_COLUMN_OFFSET : 0),
            },
            ...a.scrollbar_offset.transform,
          ],
          width: width + gutters.paddingLeft,
          maxHeight: '100%',
          overflowY: 'auto',
        }),
      ]}>
      <DesktopSearch />

      <RoomRulesSection />

      {hasSession && (
        <>
          <ProgressGuideList />
          <DesktopFeeds />
          <Divider />
        </>
      )}

      <SidebarTrendingTopics />

      <Text style={[a.leading_snug, t.atoms.text_contrast_low]}>
        {hasSession && (
          <>
            <Text
              onPress={handleFeedbackClick}
              style={[
                {color: '#fd7c21'},
                web({className: 'Feedback', cursor: 'pointer'}),
              ]}
              role="link">
              {_(msg`Feedback`)}
            </Text>
            {' • '}
          </>
        )}
        <InlineLinkText to="/support/privacy" label={_(msg`Privacy`)}>
          {_(msg`Privacy`)}
        </InlineLinkText>
        {' • '}
        <InlineLinkText label={_(msg`Help`)} to="/support">
          {_(msg`Help`)}
        </InlineLinkText>
        {' • '}
        <RNText
          onPress={() => setLegalOpen(o => !o)}
          style={[{color: '#fd7c21'}, web({cursor: 'pointer'})]}
          role="button">
          {_(msg`Legal`)}
        </RNText>
        {' • '}
        <InlineLinkText label={_(msg`About`)} to="/support/about">
          {_(msg`About`)}
        </InlineLinkText>
      </Text>
      {legalOpen && (
        <View style={[a.mt_xs, a.gap_xs]}>
          <InlineLinkText
            to="/support/community-guidelines"
            label={_(msg`Community Guidelines`)}>
            {_(msg`Community Guidelines`)}
          </InlineLinkText>
          <InlineLinkText
            to="/support/tos"
            label={_(msg`Terms of Service`)}>
            {_(msg`Terms of Service`)}
          </InlineLinkText>
          <InlineLinkText
            to="/support/privacy-policy"
            label={_(msg`Privacy Policy`)}>
            {_(msg`Privacy Policy`)}
          </InlineLinkText>
          <InlineLinkText
            to="/support/copyright"
            label={_(msg`Copyright Policy`)}>
            {_(msg`Copyright Policy`)}
          </InlineLinkText>
          <InlineLinkText
            to="/support/2257"
            label={_(msg`2257 Disclosure`)}>
            {_(msg`2257 Disclosure`)}
          </InlineLinkText>
        </View>
      )}

      {kawaii && (
        <Text style={[t.atoms.text_contrast_medium, {marginTop: 12}]}>
          <Trans>
            Logo by{' '}
            <InlineLinkText
              label={_(msg`Logo by @sawaratsuki.bsky.social`)}
              to="/profile/sawaratsuki.bsky.social">
              @sawaratsuki.bsky.social
            </InlineLinkText>
          </Trans>
        </Text>
      )}

      {!hasSession && leftNavMinimal && (
        <View style={[a.w_full, {height: 32}]}>
          <AppLanguageDropdown />
        </View>
      )}
    </View>
  )
}
